import * as React from "react";
const SvgSuccessTick = (props) => (
  <svg
    width={14}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 .333A6.67 6.67 0 0 0 .333 7 6.67 6.67 0 0 0 7 13.667 6.67 6.67 0 0 0 13.667 7 6.67 6.67 0 0 0 7 .333ZM5.193 9.86 2.8 7.467a.664.664 0 1 1 .94-.94l1.927 1.92 4.586-4.587a.664.664 0 1 1 .94.94l-5.06 5.06a.664.664 0 0 1-.94 0Z"
      fill="#1CCB57"
    />
  </svg>
);
export default SvgSuccessTick;
